export default "__VITE_PUBLIC_ASSET__86630466__"